"use client"

import { useEffect, useState } from "react"
import QuoteModal from "./quote-modal"

interface TimedQuoteModalProps {
  delaySeconds?: number // Customize delay (default: 8 seconds)
  showOnce?: boolean // Show only once per session (default: true)
}

export function TimedQuoteModal({ 
  delaySeconds = 8, 
  showOnce = true 
}: TimedQuoteModalProps = {}) {
  const [quoteModalOpen, setQuoteModalOpen] = useState(false)
  const [hasShown, setHasShown] = useState(false)

  useEffect(() => {
    // Check if modal has already been shown in this session
    if (showOnce) {
      const modalShown = sessionStorage.getItem("quoteModalShown")
      
      if (modalShown === "true") {
        setHasShown(true)
        return
      }
    }

    // Show modal after specified delay
    const timer = setTimeout(() => {
      if (!hasShown) {
        setQuoteModalOpen(true)
        if (showOnce) {
          sessionStorage.setItem("quoteModalShown", "true")
        }
        setHasShown(true)
      }
    }, delaySeconds * 1000)

    return () => clearTimeout(timer)
  }, [hasShown, delaySeconds, showOnce])

  // Don't render if already shown and modal is closed
  if (hasShown && !quoteModalOpen) {
    return null
  }

  return (
    <QuoteModal 
      quoteModalOpen={quoteModalOpen} 
      setQuoteModalOpen={setQuoteModalOpen} 
    />
  )
}
